/* eslint-disable react/display-name */
import { Redirect } from 'react-router';

// local imports
import { authRoles } from 'app/auth';
import SystemUsersList from './system-user-list';
import SystemUserAdd from './system-user-add-edit/system-user-add';
import SystemUserEdit from './system-user-add-edit/system-user-edit';

const SystemUsersConfig = {
  settings: {
    layout: {
      config: {}
    }
  },
  auth: authRoles.admin,
  routes: [
    {
      path: '/user-management/user-list',
      component: SystemUsersList,
      title: 'Kullanıcı Yönetimi - Kullanıcı Listesi',
      isAuthProtected: true
    },
    {
      path: '/user-management/add-user',
      component: SystemUserAdd,
      title: 'Kullanıcı Yönetimi - Kullanıcı Ekle',
      isAuthProtected: true
    },
    {
      path: '/user-management/:id/edit-user',
      component: SystemUserEdit,
      title: 'Kullanıcı Yönetimi - Kullanıcı Bilgisi Düzenle',
      isAuthProtected: true
    },
    {
      path: '/user-management',
      exact: true,
      component: () => <Redirect to="/user-management/user-list" />
    }
  ]
};

export default SystemUsersConfig;
